import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox, Popup } from "component/basic/popup";
import { BtnItem } from "component/basic/btns";
import { InputBoxCol2, InputItemBox } from "component/basic/formItems";
import { appType, PhoneSetting } from "js/function";
import { ProfileEditPopup, PwEditPopup } from "pages/popup/Popup";
import { FixedPage, FixedSection } from "component/basic";
import { FixedContents } from "component/product/page";
import { MypageContentsBox, MypageControll, MypageSnsItem, PageContentsSection } from "component/mypage/items";

const Edit = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const pageDataApi = useGet({
        url:`/mypage/account`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.user_info;

    const [popupData,setPopupData] =  useState(null);
    const [pwEditPopupData,setPwEditPopupData] =  useState(null);
    const [profileEditPopupData,setProfileEditPopupData] =  useState(null);
    
    //애플
    function appleLoginStart(){
        window.location.href = `https://appleid.apple.com/auth/authorize?client_id=${process.env.REACT_APP_APPLE_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_APPLE_REDIRECT_URL}`;
    }

    //구글
    function googleLoginStart(){
        if(appType() === "Android"){
            window.arentacarhub.googleLoginCheck()
        }else if(appType() === "iOS"){
            window.webkit.messageHandlers.googleLoginCheckHandler.postMessage("login");
        }else{
            window.location.href = `https://accounts.google.com/o/oauth2/auth?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_GOOGLE_REDIRECT_URL}&response_type=code&scope=openid email profile`;
        }
    }

    //네이버
    function naverLoginStart() {
        if(appType() === "Android"){
            window.arentacarhub.naverLoginCheck()
        }else if(appType() === "iOS"){
            window.webkit.messageHandlers.naverLoginCheckHandler.postMessage("login");
        }else{
            window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${process.env.REACT_APP_NAVER_CLIENT_ID}&state=false&redirect_uri=${process.env.REACT_APP_NAVER_REDIRECT_URL}`;
        }
    }

    //카카오
    function kakaoLoginStart() {
        if(appType() === "Android"){
            window.arentacarhub.kakaoLoginCheck()
        }else if(appType() === "iOS"){
            window.webkit.messageHandlers.kakaoLoginCheckHandler.postMessage("login");
        }else{
            window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.REACT_APP_KAKAO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_KAKAO_REDIRECT_URL}&response_type=code`;
        }
    }

    function snsName(type){
        let name = "";

        if(type === "naver"){
            name = "네이버"
        }else if(type === "kakao"){
            name = "카카오톡"
        }else if(type === "google"){
            name = "구글"
        }else if(type === "apple"){
            name = "애플"
        }

        return name;
    }

    useEffect(() => {
        setLoadingBoxOpen(false);

        if(sessionStorage.getItem("snsType")){
            setPopupData({
                addClass:null,
                title:"소셜 연동 완료",
                text:`<img src="/assets/images/sns/${sessionStorage.getItem("snsType")}.svg" class="snsInterlockIcon"/>${snsName(sessionStorage.getItem("snsType"))} 연동이 완료되었습니다.<br/>다음 로그인부터 ${snsName(sessionStorage.getItem("snsType"))} 로그인이 가능합니다.`,
                closeType:true,
                closeFunc:(e) => {setPopupData(null)},
                btnFunc0:(e)=>{setPopupData(null)},
                btn0:"확인",
                btn0Type:"",
                btn1:null,
                btn1Type:"",
                btnFunc1:()=>{}
            });
            sessionStorage.clear();
        }
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"계정정보 수정"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={3}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse">
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass="fixedsection_min pcItemT"
                        addClass="nonFixed fixedsection_min"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <MypageControll
                            addClass="pcItemT"
                            data={null}
                        />
                    </FixedSection>
                    <FixedContents addClass="mypageFixedContents">
                        <PageTitle
                            addClass="fixedContents_title pcItemT"
                            pageBack={null}
                            contents="계정정보 수정"
                        />
                        <PageContentsSection addClass="">
                            <MypageContentsBox
                                nPadding={false}
                                title={"회원 정보"}
                            >
                                {pageData?.login_id ? 
                                    <InputItemBox
                                        inputType={null}
                                        addClass=""
                                        inputName="아이디"
                                        placeholder="아이디"
                                        value={pageData?.login_id}
                                        max={null}
                                        regexp={null}
                                        readOnly={true}
                                        func={(value)=>{}}
                                    />
                                :""}
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="휴대폰 번호"
                                    placeholder="010-1234-1234"
                                    value={pageData?.phone ? PhoneSetting(pageData?.phone) : ""}
                                    max={null}
                                    regexp={null}
                                    readOnly={true}
                                    func={(value)=>{}}
                                />
                                <BtnItem
                                    addClass="subColor"
                                    contents={"휴대폰 번호 변경"}
                                    func={() => {
                                        setProfileEditPopupData({
                                            addClass:"subTitle_line_2",
                                            title:"회원정보 변경",
                                            subTitle:"회원정보 변경을 위해선<br/>본인인증이 필요해요",
                                            closeType:true,
                                            closeFunc:(e) => {setProfileEditPopupData(null)},
                                            textCh:(chData) => {
                                                let oldData = {...profileEditPopupData};
                                                oldData.title = chData.title;
                                                oldData.subTitle = chData.subTitle;
                                                if(chData.addClass){
                                                    oldData.addClass = chData.addClass;
                                                }
                                        
                                                setProfileEditPopupData(oldData);
                                            }
                                        });
                                    }}
                                />
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="성함"
                                    placeholder="성함"
                                    value={pageData?.name}
                                    max={null}
                                    regexp={null}
                                    readOnly={true}
                                    func={(value)=>{}}
                                />
                                <InputBoxCol2>
                                    <InputItemBox
                                        inputType={null}
                                        addClass=""
                                        inputName="생년월일"
                                        placeholder="YYYYMMDD"
                                        value={pageData?.birth}
                                        max={null}
                                        regexp={"number"}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        readOnly={true}
                                        func={(value)=>{}}
                                    />
                                    <InputItemBox
                                        inputType={null}
                                        addClass=""
                                        inputName="성별"
                                        placeholder="성별"
                                        value={pageData?.gender === "m" ? "남성" : "여성"}
                                        max={null}
                                        regexp={null}
                                        readOnly={true}
                                        func={(value)=>{}}
                                    />
                                </InputBoxCol2>
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="이메일"
                                    placeholder="username@gmail.com"
                                    value={pageData?.email}
                                    max={null}
                                    regexp={null}
                                    readOnly={true}
                                    func={(value)=>{}}
                                />
                                <BtnItem
                                    addClass="subColor"
                                    contents={"새 비밀번호 설정"}
                                    func={() => {
                                        setPwEditPopupData({
                                            addClass:"subTitle_line_1",
                                            title:"새로운 비밀번호 설정",
                                            subTitle:"로그인 시 사용할 새로운 비밀번호를 입력해주세요.",
                                            closeType:true,
                                            closeFunc:(e) => {setPwEditPopupData(null)}
                                        });
                                    }}
                                />
                            </MypageContentsBox>
                            <MypageContentsBox
                                nPadding={false}
                                title={"소셜 연동 정보"}
                                captions={[
                                    "소셜 계정을 연동하면 간편하게 로그인이 가능합니다."
                                ]}
                            >
                                <MypageSnsItem
                                    name={"네이버"}
                                    status={pageData?.is_naver}
                                    func={()=>{naverLoginStart()}}
                                />
                                <MypageSnsItem
                                    name={"카카오톡"}
                                    status={pageData?.is_kakao}
                                    func={()=>{kakaoLoginStart()}}
                                />
                                <MypageSnsItem
                                    name={"구글"}
                                    status={pageData?.is_google}
                                    func={()=>{googleLoginStart()}}
                                />
                                <MypageSnsItem
                                    name={"애플"}
                                    status={pageData?.is_apple}
                                    func={()=>{appleLoginStart()}}
                                />
                            </MypageContentsBox>
                        </PageContentsSection>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <PwEditPopup
                popupData={pwEditPopupData}
                close={()=>{setPwEditPopupData(null)}}
            />
            <ProfileEditPopup
                popupData={profileEditPopupData}
                close={()=>{setProfileEditPopupData(null)}}
            />
            <Popup
                data={popupData}
            />
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Edit;